import { bbxKind } from '../agents/bbx-kind.js';
import { OcrExtractionType } from '../agents/extraction-modules/ocrExtractionTypes.js';
import { type TaskTypeBehaviour } from './task-main.js';

export const calculationBehaviour = {
  implemented: true,
  structureAgentPrompt: '',
  examCreationPrompt: '',
  boundingBox: {
    [bbxKind.STUDENT_ANSWER]: '',
    [bbxKind.MS]: '',
    [bbxKind.GS]: '',
    [bbxKind.TASKS]: '',
  },
  OCR: {
    [OcrExtractionType.STUDENT_ANSWER]: '',
    [OcrExtractionType.TASK_DESCRIPTION]: '',
    [OcrExtractionType.MASTER_SOLUTION]: '',
    [OcrExtractionType.GRADING_CRITERIA]: '',
  },
  generateMS: `- The master solution should state all necessary steps to solve the task and should be well structured such that it can be followed and understood by a person who is not familiar with the task.
  - If a Theorem or a formula is used in the solution that is not stated in the task description or additional info, it should be explicitly stated that it is used and the theorem or formula should be stated in the master solution.
  - include the correct units in the master solution if the task description or additional info states that or where appropriate.`,
  generateGS: `- If the task maximum points are above 2 points subtract 1 points once if the master solution requires units and the student solution does not include them or includes wrong units. If the max points are 2 or below, subtract 0.5 points for missing or wrong units once.`,
  grading:
    '- The solution of the student must be correct and well structured such that it can be followed and understood by a person who is not familiar with the task. ',
  // Math notation (equations, symbols, workings) is not reliably transcribed by OCR.
  // Student answer boxes skip OCR and are stored as image for downstream LLM vision processing.
  forceImage: true,
} satisfies TaskTypeBehaviour;
